export const LABELS = {
  PROFILE: ['orderTableCell.layout.profileMenu.profile', 'Profile'],
  RAMP_ACCOUNTS: ['orderTableCell.layout.profileMenu.rampAccounts', 'Crypto Ramp Accounts'],
  PWC_ACCOUNTS: ['orderTableCell.layout.profileMenu.pwcAccounts', 'Pay with Crypto Accounts'],
  ACCOUNTS: ['orderTableCell.layout.profileMenu.accounts', 'Accounts'],
  CREATE_ACCOUNT: ['orderTableCell.layout.profileMenu.createAccount', 'Create New Account'],
  LOGOUT: ['orderTableCell.layout.profileMenu.logout', 'Logout'],
  DEFAULT_LABEL: ['orderTableCell.layout.profileMenu.defaultLabel', 'Shift4'],
};
